import { render } from "./LInput.vue?vue&type=template&id=235c46b6&scoped=true&ts=true"
import script from "./LInput.vue?vue&type=script&lang=ts"
export * from "./LInput.vue?vue&type=script&lang=ts"

import "./LInput.vue?vue&type=style&index=0&id=235c46b6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235c46b6"]])

export default __exports__